"use client";
import { ReactNode, useEffect } from "react";
import { Box } from "@mui/material";
import { useSelector } from "@/redux/store";
import { useRouter } from "next/navigation";
import {
  appInitializationCompleted,
  setCompanyId,
  setMarketplaceName,
} from "@/redux/appSlice";
import { useDispatch } from "react-redux";
import { LoginStatus } from "@/redux/authSlice";
import Loading from "@/components/Loading";
import {
  useLazyGetCompanyMarketplaceQuery,
  useLazyGetCompanyUserByIdQuery,
} from "@/redux/api/company";
interface LayoutProps {
  children: ReactNode;
}

export default function Template({ children }: LayoutProps) {
  const loginStatus = useSelector((state) => state.auth.loginStatus);
  const router = useRouter();
  const dispatch = useDispatch();
  const isAppInitialize = useSelector((state) => state.app.isAppInitialize);
  const [
    triggerGetCompany,
    { data: companyData, isSuccess: isSuccessCompany, isError: isErrorCompany },
  ] = useLazyGetCompanyUserByIdQuery();

  const [
    triggerGetMarketPlace,
    { data: marketPlaceData, isSuccess: isSuccessMP, isError: isErrorMP },
  ] = useLazyGetCompanyMarketplaceQuery();
  const companyId = useSelector((state) => state.app.companyId);
  const marketplaceName = useSelector((state) => state.app.marketplaceName);

 

  useEffect(() => {
    if (loginStatus != LoginStatus.INITIAL) {
      dispatch(appInitializationCompleted());
    }
  }, [loginStatus, router, isAppInitialize, dispatch]);

  useEffect(() => {
    if (
      companyData != undefined &&
      companyData.length == 0 &&
      isSuccessCompany &&
      loginStatus == LoginStatus.AUTHORIZED
    ) {
      router.push("/company/add");
    }
  }, [isSuccessCompany, companyData, loginStatus, router]);

  useEffect(() => {
    if (loginStatus == LoginStatus.AUTHORIZED) {
      triggerGetCompany();
    }
  }, [loginStatus, triggerGetCompany]);

  useEffect(() => {
    if (companyData != null && companyData.length > 0) {
      const companyId = companyData[0].id;
      dispatch(setCompanyId(companyId));
      triggerGetMarketPlace(companyId);
    }
  }, [companyData, triggerGetMarketPlace, dispatch]);

  useEffect(() => {
    if (marketPlaceData != null && marketPlaceData.length > 0) {
      const marketPlaceName = marketPlaceData[0];
      dispatch(setMarketplaceName(marketPlaceName));
    }
  }, [marketPlaceData, dispatch]);

  useEffect(() => {
    if (
      companyId &&
      marketplaceName &&
      loginStatus == LoginStatus.AUTHORIZED &&
      isAppInitialize
    ) {
      router.push(`${companyId}/${marketplaceName}/dashboard`);
    }
  }, [loginStatus, isAppInitialize, companyId, marketplaceName, router]);

  if (!isAppInitialize || loginStatus == LoginStatus.AUTHORIZED) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        bgcolor: "var(--mui-palette-background-default)",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        minHeight: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          pl: { lg: "var(--SideNav-width)" },
        }}
      >
        <div>{children}</div>
      </Box>
    </Box>
  );
}


